import { useEffect, useState } from "react";
import { useLocalSettingsProvider } from "../local-settings";
import { SIMULATOR_CLIENT_URL } from "./constants";
import { Options, UseTyroIClientResponse } from "./types";

export const useTyroIClient = ({
  mode,
  ...options
}: Options): UseTyroIClientResponse => {
  const [initialized, setInitialized] = useState(false);
  const [iClient, setIClient] = useState<any>(undefined);
  const localSettings = useLocalSettingsProvider();

  useEffect(() => {
    const url =
      mode === "DEV"
        ? localSettings.settings.useTyroSimulator
          ? SIMULATOR_CLIENT_URL
          : "OTHER URL"
        : "https://iclient.tyro.com/iclient-v1.js";

    const script = document.createElement("script");
    const { apiKey, ...remainingOptions } = options;

    const tyroOptions = {
      posProductVendor: "Towersystems",
      posProductName: "Roam2",
      posProductVersion: "2.0.0",
      ...remainingOptions,
    };

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    script.addEventListener("load", () => {
      //@ts-ignore
      const tyro = window.TYRO;

      if (tyro) {
        //@ts-ignore
        setIClient(new tyro.IClient(apiKey || "l", tyroOptions));
        setInitialized(true);
      }
    });

    return () => {
      setIClient(undefined);
      document.body.removeChild(script);
    };
  }, []);

  return {
    iClient,
    initialized,
  };
};
